import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, ArrowRight } from "lucide-react";

export default function TemplateMinimal({ site }) {
  const { brand_name, color_primary, phone, email, products, headline, tagline } = site;
  const p = color_primary || "#0f172a"; // slate-900 default

  return (
    <div className="min-h-screen bg-[#FAFAF9] font-body">
      {/* Nav */}
      <nav className="max-w-4xl mx-auto px-6 py-8 flex items-center justify-between">
        <span style={{ color: p }} className="font-heading font-bold text-2xl tracking-tight">{brand_name || "DTH"}</span>
        <Link to="login" style={{ color: p, borderColor: p }} className="text-sm font-semibold border-b-2 pb-0.5 hover:opacity-70 transition-opacity">Login</Link>
      </nav>

      {/* Hero */}
      <section className="max-w-4xl mx-auto px-6 py-16">
        <h1 style={{ color: p }} className="font-heading font-black text-5xl md:text-7xl leading-[1.05] tracking-tighter">
          {headline ? headline : <>Simple DTH.<br />Simply recharge.</>}
        </h1>
        <p className="mt-6 text-xl text-slate-500 max-w-lg leading-relaxed">
          {tagline || "No clutter. No hassle. Pick a plan, pay, and watch. That's it."}
        </p>
        <button style={{ color: p, borderColor: p }} className="mt-8 inline-flex items-center gap-2 text-lg font-semibold border-b-2 pb-1 hover:opacity-70 transition-opacity">
          View plans <ArrowRight className="w-5 h-5" />
        </button>
      </section>

      {/* Divider */}
      <div className="max-w-4xl mx-auto px-6"><hr className="border-slate-200" /></div>

      {/* Plans */}
      <section className="max-w-4xl mx-auto px-6 py-16">
        <h2 className="font-heading font-bold text-sm uppercase tracking-[0.2em] text-slate-400 mb-8">Available Plans</h2>
        <div className="space-y-4">
          {(products || []).slice(0, 8).map((p_item, i) => (
            <div key={p_item.id || i} className="flex items-center justify-between py-5 border-b border-slate-200 group cursor-pointer hover:bg-white px-4 -mx-4 rounded-lg transition-all">
              <div>
                <h3 style={{ color: p }} className="font-heading font-bold text-lg">{p_item.name}</h3>
                <p className="text-sm text-slate-500 mt-0.5">{p_item.operator} • {p_item.validity_days} days{p_item.channel_count ? ` • ${p_item.channel_count} ch` : ""}</p>
              </div>
              <div className="text-right flex items-center gap-4">
                <span style={{ color: p }} className="font-heading font-bold text-2xl">₹{p_item.sell_price}</span>
                <ArrowRight style={{ color: p }} className="w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </div>
          ))}
        </div>
        {(!products || products.length === 0) && <p className="text-slate-400">Plans coming soon.</p>}
      </section>

      {/* Footer */}
      <footer className="max-w-4xl mx-auto px-6 py-12 border-t border-slate-200">
        <div className="flex flex-col md:flex-row items-start justify-between gap-6">
          <div>
            <span style={{ color: p }} className="font-heading font-bold text-lg">{brand_name}</span>
            <p className="text-sm text-slate-500 mt-1">Your trusted DTH provider.</p>
          </div>
          <div className="flex gap-6 text-sm text-slate-500">
            {phone && <a href={`tel:${phone}`} style={{ color: p }} className="flex items-center gap-1 hover:opacity-70"><Phone className="w-4 h-4" />{phone}</a>}
            {email && <a href={`mailto:${email}`} style={{ color: p }} className="flex items-center gap-1 hover:opacity-70"><Mail className="w-4 h-4" />{email}</a>}
            <Link to="privacy-policy" style={{ color: p }} className="hover:opacity-70 transition-opacity">Privacy Policy</Link>
          </div>
        </div>
        <div className="mt-8 pt-4 border-t border-slate-200 text-center text-xs text-slate-400">
          Powered by : Oxiaim Techbreed Pvt. Ltd.
        </div>
      </footer>
    </div>
  );
}
